<template>
  <section class="card" v-if="item">
    <div class="card__header _mb-6">
      <picture v-if="item.images && item.images.length">
        <source
          v-for="(img, ind) in item.images"
          :key="ind"
          :srcset="img.src"
          :media="img.media"
        />
        <img
          class="card__header-img"
          :src="item.images[item.images.length - 1].src"
        />
      </picture>
      <img class="card__header-img" v-if="item.preview" :src="item.preview" />
      <div class="card-view d-flex" v-if="item.view">
        <span class="_fs-14 _lh-12 _tc-white _my-auto">{{
          $t("interface.video.view")
        }}</span>
        <svg
          class="_ml-2"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.833374 10C0.833374 10 4.16671 3.33337 10 3.33337C15.8334 3.33337 19.1667 10 19.1667 10C19.1667 10 15.8334 16.6667 10 16.6667C4.16671 16.6667 0.833374 10 0.833374 10Z"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 12.5C11.3808 12.5 12.5 11.3808 12.5 10C12.5 8.61933 11.3808 7.50004 10 7.50004C8.61933 7.50004 7.50004 8.61933 7.50004 10C7.50004 11.3808 8.61933 12.5 10 12.5Z"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div
        class="card-video"
        v-if="item.file || item.video"
        @click="watch(item.file || item.video)"
      >
        <div
          class="card-video__play card-btn btn btn_primary _px-4 _py-3"
          v-if="isVideo"
        >
          {{ $t("interface.video.watch") }}
          <svg
            class="_ml-2"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.3263 11.2061C18.2246 11.6984 18.2246 12.9683 17.3263 13.4606L9.95318 17.5014C9.0777 17.9812 8 17.3592 8 16.3741L8 8.29258C8 7.3075 9.0777 6.68551 9.95318 7.16531L17.3263 11.2061Z"
              fill="white"
            />
          </svg>
        </div>
        <div
          class="card-video__time _pa-1 _tc-white _fs-14 _lh-12 _fw-500"
          v-if="
            (item.file || item.video) &&
            videoTime &&
            isVideo &&
            Object.keys(videoTime).length
          "
        >
          {{ videoTime.hours }} : {{ videoTime.minutes }} :
          {{ videoTime.seconds }}
        </div>
        <div class="card-video__progress" v-if="isVideo">
          <div
            class="card-video__progress-line"
            :style="`width: ${progressLine}%`"
          ></div>
        </div>
      </div>
    </div>
    <CardFavorite
      v-if="!hideFavorites"
      @like="like"
      @favorite="favorite"
      :like="item.like"
      :favorite="item.favorite"
      :likesCount="item.likes_count"
    />

    <p
      class="card__date _mt-4 _mb-6 _fs-20 _fs-sm-16 _tc-dark-grey _fw-600 _px-md-4"
      v-if="item.date"
    >
      {{ item.date }}
    </p>

    <h3
      class="_fs-24 _fs-sm-20 _lh-32 _lh-sm-24 _fw-700 _mb-2 _px-sm-4"
      v-html="item.title"
    ></h3>
    <div
      class="_fs-20 _px-md-4 _mb-6 _lh-26 card__description"
      v-if="item.description"
      v-html="item.description"
    ></div>
    <div
      class="_fs-20 _px-md-4 _mb-6 _lh-26 card__speaker"
      v-if="item.speakers && item.speakers.length"
    >
      <div class="_fs-20 _lh-24 _tc-green-second _fw-700 _mb-2">
        {{ $t("interface.video.speaker") }}
      </div>
      <div v-for="speaker in item.speakers" :key="speaker.id" class="_mb-4">
        <div class="_fs-20 _lh-24 _tc-dark-grey _fw-700 _mb-2">
          {{ speaker.name }}
        </div>
        <div class="_fs-20 _lh-24 _tc-dark-grey">
          {{ speaker.description }}
        </div>
      </div>
    </div>
    <div class="d-flex align-center _px-sm-4 _px-md-0">
      <AppBtn
        class="_mr-4"
        v-if="(item.file || item.video) && !simple && !hideDownload"
      >
        <div
          @click="downloadFile()"
          class="d-flex _fs-16 _tc-white _lh-24 _fw-500 _py-3 _px-6"
        >
          <svg
            class="_mr-2"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          {{ $t("interface.video.download") }}
        </div>
      </AppBtn>
      <div
        class="_fs-20 _lh-22 _tc-grey-light d-flex align-center"
        v-if="!simple"
      >
        <span>{{
          isVideo
            ? $t("interface.video.type_video")
            : $t("interface.video.type_doc")
        }}</span>

        <div class="d-inline-flex align-center" v-if="item.coins">
          <img
            :src="require('@/assets/img/leaderboard/coins.png')"
            width="30"
            height="30"
            class="_mr-2 _ml-2"
          />
          {{ item.coins }}
          {{ $tc("cabinet.dashboard.cards[1].tip", item.coins) }}
        </div>
      </div>
    </div>
    <slot name="button" v-bind:item="item" />
    <CardSharing
      v-if="!simple"
      class="_mt-4"
      :title="item.title"
      :description="item.description"
      :image="item.preview"
      :url="
        $route.path + '?' + objectToQuery($route.query) + '#intensive' + item.id
      "
      :analyticEventPrefix="analyticEventPrefix"
    />
  </section>
</template>

<script>
import { bus } from "@/main";
import CardSharing from "@/components/UI/cards/CardSharing.vue";
import CardFavorite from "@/components/UI/cards/CardFavorite.vue";
import AppBtn from "../buttons/AppBtn.vue";
import fileSize from "@/mixins/fileSize";
export default {
  name: "VideoCard",
  mixins: [fileSize],
  props: {
    item: Object,
    parentSlug: String,
    hideDownload: Boolean,
    simple: { type: Boolean, default: false },
    analyticEventPrefix: String,
    hideFavorites: Boolean,
  },
  data: () => ({
    videoTime: {},
    progressLine: null,
    isVideo: false,
    isFile: false,
  }),
  components: { CardSharing, CardFavorite, AppBtn },
  computed: {},

  methods: {
    objectToQuery(obj) {
      return new URLSearchParams(obj).toString();
    },
    async videoProgress(url) {
      let result = {};
      if (this.item && this.item.extras && this.item.extras.duration) {
        let hours = this.item.extras.duration / 3600;
        let fullHours = Math.floor(hours);
        let minutes = (hours - Math.floor(hours)) * 60;
        let fullMinutes = Math.floor(minutes);
        let seconds = (minutes - Math.floor(minutes)) * 60;
        let fullSeconds = Math.round(seconds);
        result = {
          duration: this.item.extras.duration,
          hours: fullHours.toString().padStart(2, "0"),
          minutes: fullMinutes.toString().padStart(2, "0"),
          seconds: fullSeconds.toString().padStart(2, "0"),
        };
        this.videoTime = result;
        return;
      }
      let video = document.createElement("video");
      video.src = url;
      video.preload = "metadata";
      const res = new Promise((resolve) => {
        video.onloadedmetadata = function () {
          window.URL.revokeObjectURL(video.src);
          let hours = video.duration / 3600;
          let fullHours = Math.floor(hours);
          let minutes = (hours - Math.floor(hours)) * 60;
          let fullMinutes = Math.floor(minutes);
          let seconds = (minutes - Math.floor(minutes)) * 60;
          let fullSeconds = Math.round(seconds);
          result = {
            duration: video.duration,
            hours: fullHours.toString().padStart(2, "0"),
            minutes: fullMinutes.toString().padStart(2, "0"),
            seconds: fullSeconds.toString().padStart(2, "0"),
          };
          resolve(result);
        };
      });
      this.videoTime = await res;
    },
    watch(src) {
      if (this.$gtm && this.analyticEventPrefix) {
        this.$gtm.push({
          event: this.analyticEventPrefix + "_start",
          param_value: this.helpers.stripHtml(this.item.title),
        });
      }
      bus.$emit(
        "playVideo",
        src,
        this._uid,
        this.item.progress,
        this.item.view,
        this.isVideo,
        this.isFile,
        this.item.title
      );
    },
    async videoClose(obj) {
      if (this._uid === obj.uid && obj.time > this.item.progress) {
        this.progressLine = (obj.time * 100) / (obj.el.duration || 1);
        this.$emit(
          "setVideoProgress",
          this.item.id,
          obj.time,
          this.item.content_type || null
        );
      }
      if (this._uid === obj.uid && this.progressLine > 95 && !this.item.view) {
        this.$emit("viewItem", this.item.id, this.item.content_type || null);
      }
      if (this._uid === obj.uid && this.progressLine > 95 && !obj.noGTM) {
        if (this.$gtm && this.analyticEventPrefix) {
          this.$gtm.push({
            event: this.analyticEventPrefix + "_end",
            param_value: this.helpers.stripHtml(this.item.title),
          });
        }
      }
    },
    async documentClose(obj) {
      if (this._uid === obj.uid) {
        this.$emit("viewItem", this.item.id, this.item.content_type || null);
        if (this.$gtm && this.analyticEventPrefix) {
          this.$gtm.push({
            event: this.analyticEventPrefix + "_end",
            param_value: this.helpers.stripHtml(this.item.title),
          });
        }
      }
    },
    get_url_extension(url) {
      return url.split(/[#?]/)[0].split(".").pop().trim();
    },
    async downloadFile() {
      this.$emit(
        "downloadFile",
        this.item.file || this.item.video,
        this.item.title +
          "." +
          this.get_url_extension(this.item.file || this.item.video)
      );
      if (this.$gtm && this.analyticEventPrefix) {
        this.$gtm.push({
          event: this.analyticEventPrefix + "_download",
          param_value: this.helpers.stripHtml(this.item.title),
        });
      }
    },
    async like() {
      this.$emit("like", this.item.id, this.item.content_type || null);
      if (!this.item.like) {
        if (this.$gtm && this.analyticEventPrefix) {
          this.$gtm.push({
            event: this.analyticEventPrefix + "_like",
            param_value: this.helpers.stripHtml(this.item.title),
          });
        }
      }
    },
    async favorite() {
      this.$emit("favorite", this.item.id, this.item.content_type || null);
      if (!this.item.favorite) {
        if (this.$gtm && this.analyticEventPrefix) {
          this.$gtm.push({
            event: this.analyticEventPrefix + "_to_favorite",
            param_value: this.helpers.stripHtml(this.item.title),
          });
        }
      }
    },
  },
  async mounted() {
    if (this.item.file || this.item.video) {
      let video = this.item.file || this.item.video;
      const extension = video.match(/\.([^.]+)$|$/)[1].toLowerCase();
      const videoTypes = [
        "flv",
        "mp4",
        "m3u8",
        "ts",
        "3gp",
        "mov",
        "avi",
        "wmv",
      ];
      const fileType = ["pdf", "png", "jpg", "jpeg"];
      this.isVideo = videoTypes.includes(extension);
      this.isFile = fileType.includes(extension);
      if (this.isVideo && this.isFile) {
        await this.videoProgress(video);
        this.progressLine =
          (this.item.progress * 100) / this.videoTime.duration;
        bus.$on("onClose", this.videoClose);
      } else {
        bus.$on("onClose", this.documentClose);
      }
    }
    if (
      this.$route &&
      this.$route.hash &&
      this.item.id == this.$route.hash.replace("#intensive", "")
    ) {
      this.watch(this.item.file || this.item.video);
    }
  },
  beforeDestroy() {
    bus.$off("onClose", this.videoClose);
    bus.$off("onClose", this.documentClose);
  },
};
</script>

<style lang="scss" scoped>
.card {
  &__header {
    position: relative;
    height: calc(100vw * 0.263);
    min-height: 240px;
    max-height: 320px;
    border-radius: 16px;
    background-color: color(green-light);
    overflow: hidden;
    width: 100%;
    &-img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      object-fit: cover;
      transition: all 0.5s ease;
    }
    &:hover &-img {
      transform: scale(1.05);
    }

    @media screen and (max-width: 1220px) {
      height: 380px;
      max-height: none;
    }
    @media screen and (max-width: 743px) {
      height: 210px;
    }
  }

  &__favorite {
    display: flex;
    align-items: center;
  }

  &__description {
    color: color(dark-grey);
  }

  &-view {
    padding: 8px;
    position: absolute;
    top: 30px;
    right: 30px;
    background: rgba(37, 40, 42, 0.6);
    border-radius: 2px;
  }

  &-video {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 100;
    z-index: 2;
    &__play {
      position: absolute;
      bottom: 25px;
      left: 30px;
      display: flex;
    }
    &__time {
      position: absolute;
      right: 30px;
      bottom: 30px;
      background-color: rgba(37, 40, 42, 0.4);
      border-radius: 2px;
    }
    &__progress {
      width: 100%;
      height: 9px;
      position: absolute;
      bottom: 0;
      background-color: rgba(37, 40, 42, 0.4);
      &-line {
        width: 0;
        height: 100%;
        background-color: #77bb2f;
        z-index: 1;
      }
    }
  }
}
</style>
